import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { GlobalService } from '../global/global.service';


@Injectable()
export class SupplierService {
  constructor(private http: HttpClient, private globalService: GlobalService) { }

  token = localStorage.getItem('key');
  urlContaE = this.globalService.urlContaE();
  //urlMiPortal = this.globalService.urlMiPortal();
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  public Supplier_UploadFileExtra(Id_Supplier_Data, File): Observable<any> {
    const formData = new FormData();
    const UserToken = localStorage.getItem('key')
    if (File != null && File != undefined) { formData.append('Files', File.file.rawFile); }

    return this.http.post<any>(this.urlContaE + 'api/Supplier/Supplier_UploadFileExtra?UserToken=' + UserToken + '&Id_Supplier_Data=' + Id_Supplier_Data, formData)
      .catch(error => {
        return Observable.throw(error || 'Internal Server error');
      });
  }

  public Supplier_File_Extra(Id_Supplier_Data): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Supplier_Data: Id_Supplier_Data
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Supplier/Supplier_File_Extra', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public Supplier_File_Extra_Update(Id_Supplier_Document_Extra, Name, Is_Deleted, Id_Supplier_Data): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Supplier_Document_Extra: Id_Supplier_Document_Extra,
      Name: Name,
      Is_Deleted: Is_Deleted,
      Id_Supplier_Data: Id_Supplier_Data
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Supplier/Supplier_File_Extra_Update', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public Supplier_File_Extra_Avalible(Id_Supplier_Data): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
      Id_Supplier_Data: Id_Supplier_Data
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Supplier/Supplier_File_Extra_Avalible', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }

  public Supplier_Validity_Fiscal_Opinion(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key'),
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(
      this.urlContaE + 'api/Supplier/Supplier_Validity_Fiscal_Opinion', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/rest/Supplier.service.ts